// extracted by mini-css-extract-plugin
module.exports = {"responsiveHeader":"ResponsiveHeader_responsiveHeader__3ozyK","responsiveHeader_portrait":"ResponsiveHeader_responsiveHeader_portrait__3F8O7"};